import React from "react";
import { Helmet } from "react-helmet-async";

import { Alert, Backdrop, Box, Snackbar } from "@mui/material";

import ComponentAbstract from "components/ComponentAbstract";
import ImageError from "components/ImageError";
import _helper from "actions/_helper";

export default class AppView extends ComponentAbstract {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            alertError: "",
            loading: false,
            dialogProps: null,
            previewProps: null,
        };
    }

    alertError(alertError) {
        this.setState({ alertError });
    }

    logout() {
        this.setState({ loading: true });
    }

    setLoading(loading, cb) {
        this.setState({ loading }, cb?.apply ? cb : null);
    }

    showHideDialog(dialogProps) {
        this.setState({ dialogProps });
    }

    showHidePreview(previewProps) {
        this.setState({ previewProps });
    }

    insertPreview(previewProps) {
        const opened = !!previewProps;
        if (!opened)
            return <></>;

        const { src, type } = previewProps || {};

        return (
            <Backdrop
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={opened}
                className="previewPopup"
                onClick={this.showHidePreview.bind(this, null)}
            >
                {type === "video" ? (
                    <video src={src} autoPlay controls className="video"></video>
                ) : (
                    <ImageError
                        src={src}
                        className="img"
                        alt="Preview"
                        onLoad={ev => {
                            if (ev?.target) {
                                const { naturalHeight } = ev.target;
                                ev.target.style = `height: ${naturalHeight}px; opacity: 1`;
                            }
                        }}
                    />
                )}
            </Backdrop>
        );
    }

    insertGlobalDialog(dialogProps) {
        return this.insertDialog(dialogProps, this.showHideDialog.bind(this, null));
    }

    insertAlert(alertError) {
        const opened = !!alertError;
        const closeCb = this.alertError.bind(this, "");

        return (
            <Snackbar
                open={opened}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                onClose={closeCb}
            >
                {opened ? (
                    <Alert severity="error" variant="filled" onClose={closeCb}>
                        {alertError}
                    </Alert>
                ) :
                    <Box></Box>
                }
            </Snackbar>
        );
    }

    renderView() {
        return <></>;
    }

    render() {
        globalThis.appView = this;
        globalThis._helper = _helper;

        const { pageTitle } = _helper.getPageTitle();
        const { loading, alertError, dialogProps, previewProps } = this.state;

        return (
            <>
                <Helmet>
                    <title>{pageTitle}</title>
                </Helmet>
                {this.renderView()}
                {this.insertPreview(previewProps)}
                {!!dialogProps && this.insertGlobalDialog(dialogProps)}
                {!!loading && this.insertLoading()}
                {this.insertAlert(alertError)}
            </>
        );
    }
}